import { alpha, createTheme } from "@mui/material/styles";

export const demoTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: "data-toolpad-color-scheme",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  colorSchemes: {
    light: {
      palette: {
        mode: "light",
        primary: {
          main: "#1976d2",
          contrastText: "#ffffff",
        },
        secondary: {
          main: "#9c27b0",
          contrastText: "#ffffff",
        },
        background: {
          default: "#FBFDFF", // A very subtle, almost luminous light blue-white background. (UNCHANGED)
          paper: alpha("#FFFFFF", 0.99), // Near-pure white for elevated surfaces, allowing subtle blur effects. (UNCHANGED)
        },
        text: {
          primary: "#212121",
          secondary: "#555",
        },
        action: {
          active: alpha("#00707D"), // (ENHANCED)
          hover: alpha("#00707D", 0.08), // (ENHANCED)
          selected: alpha("#00707D", 0.16), // (ENHANCED)
          disabled: alpha("#00707D", 0.4), // Stronger disabled contrast. (ENHANCED)
          disabledBackground: alpha("#00707D", 0.08), // (ENHANCED)
          focus: alpha("#00707D", 0.12), // (ENHANCED)
        },
        divider: alpha("#BDC3C7", 0.6), // Clearly visible but not harsh divider. (ENHANCED)
      },
    },
    dark: {
      palette: {
        mode: "dark",
        primary: {
          main: "#90caf9",
          contrastText: "#000000",
        },
        secondary: {
          main: "#ce93d8",
          contrastText: "#000000",
        },
        background: {
          default: "#121212", // soft dark (not black)
          paper: "#1e1e1e",
        },
        text: {
          primary: "#ffffff",
          secondary: "#b0bec5",
        },
        action: {
          active: alpha("#66BB6A"), // (ENHANCED)
          hover: alpha("#66BB6A", 0.1), // (ENHANCED)
          selected: alpha("#66BB6A", 0.2), // (ENHANCED)
          disabled: alpha("#66BB6A", 0.4), // High contrast disabled action. (ENHANCED)
          disabledBackground: alpha("#66BB6A", 0.1), // (ENHANCED)
          focus: alpha("#66BB6A", 0.15), // (ENHANCED)
        },
        divider: alpha("#CFD8DC", 0.25), // More prominent divider for better visibility. (ENHANCED)
      },
    },
  },
  typography: {
    fontFamily: `'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
    },
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          paddingLeft: 16,
          paddingRight: 16,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 10, // Pill-like shape, slightly larger. (ENHANCED)
          fontWeight: 500, // (ENHANCED)
          padding: "4px 12px", // More comfortable padding. (ENHANCED)
          transition: "all 0.2s ease-in-out", // (ENHANCED)
          fontSize: "0.875rem", // Standard chip font size. (ENHANCED)
        }),
        filled: ({ theme }) => ({
          backgroundColor: alpha(theme.palette.primary.light, 0.18), // Richer, more visible fill. (ENHANCED)
          color: theme.palette.text.primary.dark, // Darker text for contrast. (ENHANCED)
          "&.MuiChip-clickable:hover": {
            backgroundColor: alpha(theme.palette.primary.light, 0.3), // (ENHANCED)
          },
        }),
        outlined: ({ theme }) => ({
          borderColor: alpha(theme.palette.primary.main, 0.5), // (ENHANCED)
          color: theme.palette.text.secondary, // Standard text for outlined chips. (UNCHANGED)
          "&.MuiChip-clickable:hover": {
            borderColor: theme.palette.primary.main, // (ENHANCED)
            backgroundColor: alpha(theme.palette.primary.main, 0.06), // (ENHANCED)
          },
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 18, // Consistent with overall rounded aesthetic for cards. (ENHANCED)
          boxShadow: [
            `0px 4px 8px ${alpha(theme.palette.common.black, 0.05)}`,
            `0px 8px 16px ${alpha(theme.palette.common.black, 0.1)}`,
          ].join(","), // (ENHANCED)
          border: `1px solid ${theme.palette.divider}`, // Subtle border. (ENHANCED)
          transition: "all 0.3s ease", // (ENHANCED)
          "&:hover": {
            boxShadow: [
              `0px 6px 12px ${alpha(theme.palette.common.black, 0.08)}`,
              `0px 12px 24px ${alpha(theme.palette.common.black, 0.15)}`,
            ].join(","), // (ENHANCED)
            transform: "translateY(-3px)", // More pronounced lift on hover. (ENHANCED)
          },
        }),
      },
    },
  },
});

// import { createTheme, alpha } from "@mui/material/styles";

// export const demoTheme = createTheme({
//   // Configuration for CSS variables, allowing dynamic color scheme switching.
//   cssVariables: {
//     colorSchemeSelector: "data-toolpad-color-scheme",
//   },

//   // Define standard Material-UI breakpoints for responsive design.
//   breakpoints: {
//     values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
//   },

//   // Global shape settings: defines the default border radius for components.
//   shape: { borderRadius: 12 }, // Slightly more pronounced rounded corners for a softer, modern look.

//   // Typography settings for fonts, sizes, and weights across different elements.
//   typography: {
//     // Define a robust font stack, starting with 'InterVariable' for modern systems,
//     // falling back to common sans-serif fonts for broader compatibility.
//     fontFamily: [
//       "InterVariable",
//       "Roboto",
//       "Helvetica Neue",
//       "Arial",
//       "sans-serif",
//     ].join(","),
//     h1: {
//       fontWeight: 700, // Boldest for main titles.
//       fontSize: "3.8rem", // Larger and more commanding.
//       letterSpacing: "-0.04em", // Tighter spacing for a sleek, modern feel.
//       lineHeight: 1.0, // Tighter line height for large headings.
//     },
//     h2: {
//       fontWeight: 600,
//       fontSize: "2.8rem",
//       letterSpacing: "-0.03em",
//       lineHeight: 1.1,
//     },
//     h3: {
//       fontWeight: 600,
//       fontSize: "2.2rem",
//       letterSpacing: "-0.02em",
//       lineHeight: 1.2,
//     },
//     h4: {
//       fontWeight: 500,
//       fontSize: "1.8rem",
//       lineHeight: 1.3,
//     },
//     body1: {
//       fontWeight: 400,
//       fontSize: "1.0625rem", // Optimal reading size for main content.
//       lineHeight: 1.75,
//     },
//     body2: {
//       fontWeight: 400,
//       fontSize: "0.9375rem", // Optimized for smaller, secondary text.
//       lineHeight: 1.6,
//     },
//     subtitle1: {
//       fontWeight: 500,
//       fontSize: "1.125rem", // Prominent subtitle style.
//       lineHeight: 1.5,
//     },
//     subtitle2: {
//       fontWeight: 400,
//       fontSize: "0.95rem",
//       lineHeight: 1.4,
//     },
//     button: {
//       fontWeight: 600,
//       textTransform: "none", // Keeps button text in its natural casing.
//       letterSpacing: "0.02em", // Consistent letter spacing for buttons.
//     },
//   },

//   // Define distinct color schemes for 'light' and 'dark' modes.
//   colorSchemes: {
//     light: {
//       palette: {
//         mode: "light",
//         background: {
//           default: "#FBFDFF", // A very subtle, almost luminous light blue-white background. (UNCHANGED)
//           paper: alpha("#FFFFFF", 0.99), // Near-pure white for elevated surfaces, allowing subtle blur effects. (UNCHANGED)
//         },
//         primary: {
//           main: "#00707D", // Deep, sophisticated Sapphire Teal as the primary color. (ENHANCED)
//           light: "#4ABBC7", // Brighter accent for highlights. (ENHANCED)
//           dark: "#004B54", // Deeper for contrast and depth. (ENHANCED)
//           contrastText: "#fff", // Pure white contrast text for primary elements.
//         },
//         secondary: {
//           main: "#FF6347", // Vibrant Tomato Red for a strong accent. (ENHANCED)
//           light: "#FF917A", // (ENHANCED)
//           dark: "#D6422F", // (ENHANCED)
//           contrastText: "#fff", // Pure white contrast text for secondary elements.
//         },
//         text: {
//           primary: "#2C3E50", // Dark charcoal for main text, ensuring excellent readability. (UNCHANGED)
//           secondary: "#7F8C8D", // Muted gray for secondary information, still highly readable. (UNCHANGED)
//           disabled: alpha("#2C3E50", 0.4), // Sufficient contrast for disabled text. (UNCHANGED)
//           hint: alpha("#2C3E50", 0.25), // (UNCHANGED)
//         },
//         divider: alpha("#BDC3C7", 0.6), // Clearly visible but not harsh divider. (ENHANCED)
//         action: {
//           active: alpha("#00707D", 0.1), // (ENHANCED)
//           hover: alpha("#00707D", 0.08), // (ENHANCED)
//           selected: alpha("#00707D", 0.16), // (ENHANCED)
//           disabled: alpha("#00707D", 0.4), // Stronger disabled contrast. (ENHANCED)
//           disabledBackground: alpha("#00707D", 0.08), // (ENHANCED)
//           focus: alpha("#00707D", 0.12), // (ENHANCED)
//         },
//         info: { main: "#2980B9" }, // Blue for informational messages. (ENHANCED)
//         success: { main: "#27AE60" }, // Green for success messages. (ENHANCED)
//         warning: { main: "#F39C12" }, // Orange for warnings. (ENHANCED)
//         error: { main: "#C0392B" }, // Red for error messages. (ENHANCED)
//       },
//     },

//     dark: {
//       palette: {
//         mode: "dark",
//         background: {
//           default: "#151B24", // Very deep, rich dark blue-gray background. (UNCHANGED)
//           paper: alpha("#202833", 0.98), // Slightly lighter, near-opaque dark surface for elevated elements. (UNCHANGED)
//         },
//         primary: {
//           main: "#66BB6A", // Vibrant Emerald Green for primary elements in dark mode. (ENHANCED)
//           light: "#81C784", // (ENHANCED)
//           dark: "#388E3C", // (ENHANCED)
//           contrastText: "#000", // Black contrast text for primary elements.
//         },
//         secondary: {
//           main: "#FFA726", // Bright Amber for secondary elements in dark mode. (ENHANCED)
//           light: "#FFB74D", // (ENHANCED)
//           dark: "#FB8C00", // (ENHANCED)
//           contrastText: "#000", // Black contrast text for secondary elements.
//         },
//         // CRITICAL READABILITY IMPROVEMENTS FOR DARK MODE TEXT/ICONS
//         text: {
//           primary: "#E8EDF0", // Brighter off-white for main text, improving readability. (UNCHANGED)
//           secondary: "#BFC6CC", // Noticeably lighter gray for secondary text. (UNCHANGED)
//           disabled: alpha("#E8EDF0", 0.45), // High contrast disabled text. (UNCHANGED)
//           hint: alpha("#E8EDF0", 0.3), // (UNCHANGED)
//         },
//         divider: alpha("#CFD8DC", 0.25), // More prominent divider for better visibility. (ENHANCED)
//         action: {
//           active: alpha("#66BB6A", 0.12), // (ENHANCED)
//           hover: alpha("#66BB6A", 0.1), // (ENHANCED)
//           selected: alpha("#66BB6A", 0.2), // (ENHANCED)
//           disabled: alpha("#66BB6A", 0.4), // High contrast disabled action. (ENHANCED)
//           disabledBackground: alpha("#66BB6A", 0.1), // (ENHANCED)
//           focus: alpha("#66BB6A", 0.15), // (ENHANCED)
//         },
//         info: { main: "#64B5F6" }, // (ENHANCED)
//         success: { main: "#81C784" }, // (ENHANCED)
//         warning: { main: "#FFCA28" }, // (ENHANCED)
//         error: { main: "#EF5350" }, // (ENHANCED)
//       },
//     },
//   },

//   // Overrides for individual Material-UI components to achieve specific styles.
//   components: {
//     MuiCssBaseline: {
//       styleOverrides: (theme) => ({
//         // Smooth transition for background color when switching between light/dark modes.
//         body: {
//           transition: theme.transitions.create("background-color", {
//             duration: theme.transitions.duration.standard,
//             easing: theme.transitions.easing.easeInOut,
//           }),
//           // Custom scrollbar styles for a cleaner look.
//           scrollbarColor: `${alpha(theme.palette.text.secondary, 0.5)} ${alpha(theme.palette.background.default, 0.05)}`,
//           "&::-webkit-scrollbar": {
//             width: "8px",
//             height: "8px",
//           },
//           "&::-webkit-scrollbar-thumb": {
//             backgroundColor: alpha(theme.palette.text.secondary, 0.4),
//             borderRadius: 4,
//             "&:hover": {
//               backgroundColor: alpha(theme.palette.text.secondary, 0.6),
//             },
//           },
//           "&::-webkit-scrollbar-track": {
//             backgroundColor: alpha(theme.palette.background.default, 0.05),
//           },
//         },
//       }),
//     },
//     MuiPaper: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           // Stronger frosted glass effect for elevated surfaces. (ENHANCED)
//           backdropFilter: "blur(15px) saturate(190%)",
//           // Multi-layered, more dramatic shadows for depth and a premium feel. (ENHANCED)
//           boxShadow: [
//             `0px 6px 12px ${alpha(theme.palette.common.black, 0.08)}`,
//             `0px 12px 24px ${alpha(theme.palette.common.black, 0.12)}`,
//             `0px 24px 48px ${alpha(theme.palette.common.black, 0.18)}`,
//           ].join(","),
//           border: `1px solid ${theme.palette.divider}`, // Subtle border for definition. (ENHANCED)
//           borderRadius: 16, // Softer, more luxurious rounding. (ENHANCED)
//         }),
//       },
//     },

//     MuiModal: {
//       styleOverrides: {
//         root: {
//           // Apply blur directly to the modal backdrop for a cohesive effect. (ENHANCED)
//           backdropFilter: "blur(3px)",
//           "& .MuiPaper-root": {
//             borderRadius: 20, // Even more rounded for modals, giving a distinct, high-end feel. (ENHANCED)
//           },
//         },
//       },
//     },

//     MuiButton: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           borderRadius: 10, // Harmonious with Paper, slightly less rounded. (ENHANCED)
//           fontWeight: 600,
//           textTransform: "none",
//           padding: "12px 32px", // Increased padding for a more substantial button. (ENHANCED)
//           // Smooth, responsive transition for all properties. (ENHANCED)
//           transition: "all 0.3s cubic-bezier(.25,.8,.25,1)",
//           boxShadow: `0 4px 8px ${alpha(theme.palette.common.black, 0.1)}`, // Initial shadow. (ENHANCED)
//           "&:hover": {
//             transform: "translateY(-2px)", // More noticeable lift on hover. (ENHANCED)
//             // Deeper shadow on hover for a richer effect. (ENHANCED)
//             boxShadow: `0 10px 20px ${alpha(theme.palette.common.black, 0.25)}, 0 4px 8px ${alpha(theme.palette.common.black, 0.15)}`,
//             // Ensure background color is handled by specific variant styles.
//           },
//           "&.Mui-disabled": {
//             transform: "none", // No lift when disabled. (ENHANCED)
//             boxShadow: "none", // No shadow when disabled. (ENHANCED)
//           },
//         }),
//         containedPrimary: ({ theme }) => ({
//           backgroundColor: theme.palette.primary.main,
//           color: theme.palette.primary.contrastText,
//           "&:hover": {
//             backgroundColor: theme.palette.primary.dark, // Darker shade on hover for contained primary. (ENHANCED)
//             // Box shadow is handled by the root button style.
//           },
//           "&.Mui-disabled": {
//             backgroundColor: alpha(theme.palette.primary.main, 0.4), // Highly visible disabled state. (ENHANCED)
//             color: alpha(theme.palette.primary.contrastText, 0.6), // (ENHANCED)
//           },
//         }),
//         containedSecondary: ({ theme }) => ({
//           backgroundColor: theme.palette.secondary.main,
//           color: theme.palette.secondary.contrastText,
//           "&:hover": {
//             backgroundColor: theme.palette.secondary.dark, // Darker shade on hover for contained secondary. (ENHANCED)
//             // Box shadow is handled by the root button style.
//           },
//           "&.Mui-disabled": {
//             backgroundColor: alpha(theme.palette.secondary.main, 0.4), // (ENHANCED)
//             color: alpha(theme.palette.secondary.contrastText, 0.6), // (ENHANCED)
//           },
//         }),
//         outlinedPrimary: ({ theme }) => ({
//           borderColor: alpha(theme.palette.primary.main, 0.6), // Clearer border for outlined buttons. (ENHANCED)
//           "&:hover": {
//             borderColor: theme.palette.primary.main, // (ENHANCED)
//             backgroundColor: alpha(theme.palette.primary.main, 0.08), // Slightly more visible hover. (ENHANCED)
//           },
//         }),
//         textPrimary: ({ theme }) => ({
//           "&:hover": {
//             backgroundColor: alpha(theme.palette.primary.main, 0.06), // (ENHANCED)
//           },
//         }),
//       },
//     },

//     MuiTypography: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           // Ensure all typography transitions color smoothly for theme changes. (ENHANCED)
//           transition: "color 0.3s ease",
//           color: theme.palette.text.primary, // Default to primary text color. (UNCHANGED)
//         }),
//       },
//     },

//     MuiIconButton: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           color: theme.palette.text.secondary, // Uses secondary text for icons as a base. (UNCHANGED)
//           transition: "all 0.3s ease", // (ENHANCED)
//           "&:hover": {
//             color: theme.palette.primary.main, // Primary color on hover for emphasis. (ENHANCED)
//             backgroundColor: alpha(theme.palette.primary.main, 0.12), // Distinct background on hover. (ENHANCED)
//             transform: "scale(1.08)", // More pronounced pop effect. (ENHANCED)
//           },
//         }),
//       },
//     },

//     MuiAppBar: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           backgroundColor: alpha(theme.palette.background.paper, 0.9), // Slightly less transparent for better readability. (ENHANCED)
//           backdropFilter: "blur(20px) saturate(200%)", // More intense frosted effect for the app bar. (ENHANCED)
//           boxShadow: `0 3px 12px ${alpha(theme.palette.common.black, 0.15)}`, // Stronger shadow for depth. (ENHANCED)
//           borderBottom: `1px solid ${theme.palette.divider}`, // A defining bottom border. (ENHANCED)
//         }),
//       },
//     },

//     MuiCard: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           borderRadius: 18, // Consistent with overall rounded aesthetic for cards. (ENHANCED)
//           boxShadow: [
//             `0px 4px 8px ${alpha(theme.palette.common.black, 0.05)}`,
//             `0px 8px 16px ${alpha(theme.palette.common.black, 0.1)}`,
//           ].join(","), // (ENHANCED)
//           border: `1px solid ${theme.palette.divider}`, // Subtle border. (ENHANCED)
//           transition: "all 0.3s ease", // (ENHANCED)
//           "&:hover": {
//             boxShadow: [
//               `0px 6px 12px ${alpha(theme.palette.common.black, 0.08)}`,
//               `0px 12px 24px ${alpha(theme.palette.common.black, 0.15)}`,
//             ].join(","), // (ENHANCED)
//             transform: "translateY(-3px)", // More pronounced lift on hover. (ENHANCED)
//           },
//         }),
//       },
//     },

//     MuiChip: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           borderRadius: 10, // Pill-like shape, slightly larger. (ENHANCED)
//           fontWeight: 500, // (ENHANCED)
//           padding: "4px 12px", // More comfortable padding. (ENHANCED)
//           transition: "all 0.2s ease-in-out", // (ENHANCED)
//           fontSize: "0.875rem", // Standard chip font size. (ENHANCED)
//         }),
//         filled: ({ theme }) => ({
//           backgroundColor: alpha(theme.palette.primary.light, 0.18), // Richer, more visible fill. (ENHANCED)
//           color: theme.palette.primary.dark, // Darker text for contrast. (ENHANCED)
//           "&.MuiChip-clickable:hover": {
//             backgroundColor: alpha(theme.palette.primary.light, 0.3), // (ENHANCED)
//           },
//         }),
//         outlined: ({ theme }) => ({
//           borderColor: alpha(theme.palette.primary.main, 0.5), // (ENHANCED)
//           color: theme.palette.text.secondary, // Standard text for outlined chips. (UNCHANGED)
//           "&.MuiChip-clickable:hover": {
//             borderColor: theme.palette.primary.main, // (ENHANCED)
//             backgroundColor: alpha(theme.palette.primary.main, 0.06), // (ENHANCED)
//           },
//         }),
//       },
//     },

//     MuiTabs: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           borderBottom: `1px solid ${theme.palette.divider}`, // Clear separation for tabs. (ENHANCED)
//         }),
//         indicator: ({ theme }) => ({
//           backgroundColor: theme.palette.primary.main, // (ENHANCED)
//           height: 3, // Thicker indicator for emphasis. (ENHANCED)
//           borderRadius: 2, // (ENHANCED)
//         }),
//       },
//     },

//     MuiTab: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           textTransform: "none", // Keeps normal capitalization. (ENHANCED)
//           fontWeight: 600, // (ENHANCED)
//           fontSize: "1rem", // (ENHANCED)
//           padding: "12px 16px", // (ENHANCED)
//           color: theme.palette.text.secondary, // Default tab text visible. (UNCHANGED)
//           "&.Mui-selected": {
//             color: theme.palette.text.primary, // Selected tab text primary. (UNCHANGED)
//             fontWeight: 700, // (ENHANCED)
//           },
//           "&:hover": {
//             backgroundColor: alpha(theme.palette.primary.main, 0.05), // (ENHANCED)
//           },
//           transition: "all 0.2s ease-in-out", // (ENHANCED)
//         }),
//       },
//     },

//     MuiTableHead: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           backgroundColor: alpha(theme.palette.background.paper, 0.8), // Slightly elevated table header. (ENHANCED)
//           "& .MuiTableCell-root": {
//             color: theme.palette.text.secondary, // Header text is secondary, but bright enough. (UNCHANGED)
//             fontWeight: 600, // (ENHANCED)
//             fontSize: "0.9rem", // (ENHANCED)
//             borderBottom: `1px solid ${theme.palette.divider}`, // (ENHANCED)
//             padding: "12px 16px", // (ENHANCED)
//           },
//         }),
//       },
//     },

//     MuiTableCell: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           color: theme.palette.text.primary, // Table cell text is primary. (UNCHANGED)
//           borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`, // Lighter border. (ENHANCED)
//           padding: "10px 16px", // (ENHANCED)
//         }),
//       },
//     },

//     MuiDataGrid: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           border: `1px solid ${theme.palette.divider}`, // (ENHANCED)
//           borderRadius: 12, // (ENHANCED)
//           // Row hover state.
//           "& .MuiDataGrid-row:hover": {
//             backgroundColor: alpha(theme.palette.action.hover, 0.5), // More subtle row hover. (ENHANCED)
//           },
//           // Selected row state.
//           "& .MuiDataGrid-row.Mui-selected": {
//             backgroundColor: alpha(theme.palette.action.selected, 0.5), // (ENHANCED)
//             "&:hover": {
//               backgroundColor: alpha(theme.palette.action.selected, 0.6), // (ENHANCED)
//             },
//           },
//           // Header text color (DataGrid uses MuiDataGrid-columnHeaderTitle).
//           "& .MuiDataGrid-columnHeaderTitle": {
//             color: theme.palette.text.secondary, // Header text is secondary. (UNCHANGED)
//             fontWeight: 600, // (ENHANCED)
//           },
//           // Cell text color.
//           "& .MuiDataGrid-cell": {
//             color: theme.palette.text.primary, // Cell text is primary. (UNCHANGED)
//           },
//         }),
//       },
//     },
//   },
// });
